import { SharedSample } from "../domain/sharedSample";
import { getAllSharedSampleService } from "../infrastructure/services/getAllSharedSampleService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const getAllSharedSample = {
    async execute(): Promise<SharedSample[]> {
        return await getAllSharedSampleService.execute(await tokenValidation.execute());
    },
};


